module.exports = __webpack_public_path__ + "static/media/clockF.c3b28864.png";